/** 全局统一的 BPM 可调范围：滑块、加减按钮、Tap Tempo 共用 */
export const MIN_TEMPO = 30
export const MAX_TEMPO = 240
